import { render, staticRenderFns } from "./RastrearPedido.vue?vue&type=template&id=a5215696&scoped=true"
import script from "./RastrearPedido.vue?vue&type=script&lang=js"
export * from "./RastrearPedido.vue?vue&type=script&lang=js"
import style0 from "./RastrearPedido.vue?vue&type=style&index=0&id=a5215696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5215696",
  null
  
)

export default component.exports